import { put, takeEvery } from 'redux-saga/effects';
import * as personalActions from '../../../../components/settings/actions/personal';
import { keyboardShortcutsActions } from '../actions/keyboardShortcuts';
const { personalKeyboardShortcutsSucceeded } = personalActions.actions;
const { keyboardShortcutsStart, keyboardShortcutsStop } = keyboardShortcutsActions;
// Saga
export const keyboardShortcuts = [
    takeEvery(personalKeyboardShortcutsSucceeded.toString(), personalKeyboardShortcutsSucceededGen),
];
function* personalKeyboardShortcutsSucceededGen(action) {
    try {
        if (action.payload.keyboardShortcuts == true) {
            yield put(keyboardShortcutsStart());
        }
        else {
            yield put(keyboardShortcutsStop());
        }
    }
    catch (exception) {
        console.warn('personalKeyboardShortcutsSucceededGen exception', exception);
    }
}
